import {TtActivityEntry} from '../../interfaces/time-tracking/tt-activity-entry';
import {LightUser} from '../../interfaces/core/light-user';
import {TtActivityTypeFactory} from './tt-activity-type-factory';
import {TtActivityType} from '../../interfaces/time-tracking/tt-activity-type';
import {LightCustomer} from '../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../customers/light-customer-factory';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {LightEmployee} from '../../interfaces/employees/light-employee';
import {LightUserFactory} from '../core/light-user-factory';
import {Product} from '../../interfaces/product-management/product';
import {ProductFactory} from '../product-management/product-factory';
import {TtProductEntry} from '../../interfaces/time-tracking/tt-product-entry';
import {TtProductEntryFactory} from './tt-product-entry-factory';

export class TtActivityEntryFactory {

  /**
   *
   * @param ttActivityEntry
   */
  public static fromObject(ttActivityEntry: any): TtActivityEntry {
    return new class implements TtActivityEntry {
      customer: LightCustomer =
        ttActivityEntry.customer ? LightCustomerFactory.fromObject(ttActivityEntry.customer) : null;
      customerId: number = ttActivityEntry.customer_id;
      activityDuration: number = ttActivityEntry.activity_duration;
      travelTimeBefore: number = ttActivityEntry.travel_time_before;
      timeFromTravel: string = ttActivityEntry.time_from_travel;
      emEmploymentId: number = ttActivityEntry.em_employment_id;
      employeeId: number = ttActivityEntry.employee_id;
      employee: LightEmployee = LightEmployeeFactory.fromObject(ttActivityEntry.employee);
      invMobileInvoiceId: number = ttActivityEntry.inv_mobile_invoice_id;
      isCustomerNotAtHome: boolean = ttActivityEntry.is_customer_not_at_home;
      isHomeVisit: boolean = ttActivityEntry.is_home_visit;
      isMedicalCare: boolean = ttActivityEntry.is_medical_care;
      opOperatingPlanItemId: number = ttActivityEntry.operating_plan_item_id;
      serviceId: number = ttActivityEntry.service_id;
      timeFrom: string = ttActivityEntry.time_from;
      timeTo: string = ttActivityEntry.time_to;
      ttActivityType: TtActivityType =
        ttActivityEntry.tt_activity_type ? TtActivityTypeFactory.fromObject(ttActivityEntry.tt_activity_type) : null;
      ttActivityTypeId: number = ttActivityEntry.tt_activity_type_id;
      user: LightUser = ttActivityEntry.user ? LightUserFactory.fromObject(ttActivityEntry.user) : null;
      userId: number = ttActivityEntry.user_id;
      ttWorkingTimeTypeId: number = ttActivityEntry.tt_working_time_type_id;
      activityServiceFacilityId: number = ttActivityEntry.activity_service_facility_id;

      // ------------------------------------------------------------------------------------------------
      id: number = ttActivityEntry.id;
      uuid: string = ttActivityEntry.uuid;
      modified: string = ttActivityEntry.modified;
      created: string = ttActivityEntry.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param ttActivityEntries
   */
  public static fromArray(ttActivityEntries: any[]): TtActivityEntry[] {
    return ttActivityEntries.map(_ttActivityEntry => this.fromObject(_ttActivityEntry));
  }

  /**
   *
   * @param ttActivityEntry
   */
  public static toRemote(ttActivityEntry: TtActivityEntry): any {
    return {
      customer_id: ttActivityEntry.customerId,
      em_employment_id: ttActivityEntry.emEmploymentId,
      employee_id: ttActivityEntry.employeeId,
      id: ttActivityEntry.id,
      uuid: ttActivityEntry.uuid,
      inv_mobile_invoice_id: ttActivityEntry.invMobileInvoiceId,
      is_customer_not_at_home: ttActivityEntry.isCustomerNotAtHome,
      is_home_visit: ttActivityEntry.isHomeVisit,
      is_medical_care: ttActivityEntry.isMedicalCare,
      operating_plan_item_id: ttActivityEntry.opOperatingPlanItemId,
      service_id: ttActivityEntry.serviceId,
      time_from: ttActivityEntry.timeFrom,
      time_to: ttActivityEntry.timeTo,
      time_from_travel: ttActivityEntry.timeFromTravel,
      tt_activity_type_id: ttActivityEntry.ttActivityTypeId,
      activity_service_facility_id: ttActivityEntry.activityServiceFacilityId,
    };
  }

  /**
   *
   */
  public static new(ttActivityEntry: TtActivityEntry = null): TtActivityEntry {
    const _ttActivityEntry = new class implements TtActivityEntry {
      customer: LightCustomer = null;
      customerId: number = null;
      activityDuration: number = 0;
      emEmploymentId: number = null;
      employeeId: number = null;
      employee: LightEmployee = null;
      invMobileInvoiceId: number = null;
      isCustomerNotAtHome: boolean = null;
      isHomeVisit: boolean = null;
      isMedicalCare: boolean = null;
      opOperatingPlanItemId: number = null;
      serviceId: number = null;
      timeFrom: string = null;
      timeTo: string = null;
      ttActivityType: TtActivityType = null;
      ttActivityTypeId: number = null;
      user: LightUser = null;
      userId: number = null;
      travelTimeBefore: number = null;
      timeFromTravel: string = null;
      ttWorkingTimeTypeId: number = null;
      activityServiceFacilityId: number = null;

      // ------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
      deleted: 0 | 1 = 0;
    }

    if(ttActivityEntry) {
      return {..._ttActivityEntry, ...ttActivityEntry}
    }

    return _ttActivityEntry;
  }

}
